import React from "react";
import TaggedWrVsDateChart from "../graphViewV2/charts/TaggedWrVsDateChart";
import AvgWrVsDateChart from "./charts/AvgWrVsDateChart";
import NumberFrequencyChart from "./charts/NumberFrequencyChart";
import NumberFrequencyVsBinByDateChart from "./charts/NumberFrequencyVsBinByDateChart";
import NumberFrequencyVsBinChart from "./charts/NumberFrequencyVsBinChart";
import StandardVsActualChart from "./charts/StandardVsActualChart";
import WeightVsLengthByDateChart from "./charts/WeightVsLengthByDateChart";
import WeightVsLengthChart from "./charts/WeightVsLengthChart";
import WrVsLengthChart from "./charts/WrVsLengthChart";

const REGISTRY = {
  "wr-vs-length": WrVsLengthChart,
  "weight-vs-length": WeightVsLengthChart,
  "weight-vs-length-by-date": WeightVsLengthByDateChart,
  "avg-wr-vs-date": AvgWrVsDateChart,
  "tagged-wr-vs-date": TaggedWrVsDateChart,
  "standard-vs-actual": StandardVsActualChart,
  "number-frequency": NumberFrequencyChart,
  "number-frequency-vs-bin": NumberFrequencyVsBinChart,
  "number-frequency-vs-bin-by-date": NumberFrequencyVsBinByDateChart,
};

export default function GraphChart({
  selectedGraphType,
  graphData,
  selectedUnit,
  selectedFish,
  isMobile,
  hoveredWeightPoint,
  setHoveredWeightPoint,
  selectedBinSize,
}) {
  if (!graphData.length) return null;
  const C = REGISTRY[selectedGraphType];
  if (!C) return null;

  if (
    selectedGraphType === "weight-vs-length" ||
    selectedGraphType === "weight-vs-length-by-date"
  ) {
    return (
      <C
        graphData={graphData}
        selectedUnit={selectedUnit}
        selectedFish={selectedFish}
        isMobile={isMobile}
        hoveredWeightPoint={hoveredWeightPoint}
        setHoveredWeightPoint={setHoveredWeightPoint}
      />
    );
  }

  if (
    selectedGraphType === "number-frequency-vs-bin" ||
    selectedGraphType === "number-frequency-vs-bin-by-date"
  ) {
    return (
      <C
        graphData={graphData}
        selectedUnit={selectedUnit}
        isMobile={isMobile}
        selectedBinSize={selectedBinSize}
      />
    );
  }

  if (selectedGraphType === "avg-wr-vs-date" || selectedGraphType === "tagged-wr-vs-date") {
    return <C graphData={graphData} isMobile={isMobile} />;
  }

  if (selectedGraphType === "number-frequency") {
    return (
      <C
        graphData={graphData}
        selectedUnit={selectedUnit}
        isMobile={isMobile}
        selectedBinSize={selectedBinSize}
      />
    );
  }

  return (
    <C
      graphData={graphData}
      selectedUnit={selectedUnit}
      selectedFish={selectedFish}
      isMobile={isMobile}
    />
  );
}
